import { ui } from '../styles/ui'

const BANNER_STYLE = {
  warning: ui.states.warning,
  error: ui.states.error,
}

export default function AlertBanner({
  alerts = [],
  onDismiss,
  onAcknowledge,
}) {
  const visibleAlerts = (alerts || [])
    .filter((alert) => alert?.severity === 'error' || alert?.severity === 'warning')
    .slice(0, 3)
  if (!visibleAlerts.length) return null

  return (
    <div className="fixed left-0 right-0 top-0 z-40 flex flex-col gap-2 px-4 pt-3">
      {visibleAlerts.map((alert) => {
        const style = BANNER_STYLE[alert.severity] || BANNER_STYLE.warning
        return (
          <div key={alert.id} role="alert" className={`${style} shadow-sm`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-wide">{alert.type || 'Critical alert'}</p>
                <p className="mt-1 text-sm break-words">{alert.message}</p>
              </div>
              <div className="flex items-center gap-2">
                {onAcknowledge && (
                  <button
                    type="button"
                    className={ui.buttons.smGhost}
                    onClick={() => onAcknowledge(alert.id)}
                  >
                    Ack
                  </button>
                )}
                <button
                  type="button"
                  className={ui.buttons.smGhost}
                  onClick={() => onDismiss?.(alert.id)}
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
